module.exports = __webpack_public_path__ + "static/img/user.393c835.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Search/user.jpg
// module id = R5sb
// module chunks = 1